import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=7f216fb2&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=7f216fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f216fb2",
  null
  
)

export default component.exports